import { useLingui } from "@lingui/react";
import React, { useMemo } from "react";
import { Link, useMatches, useParams } from "react-router-dom";

import { cn } from "@/utils/shadcn-ui";

import styles from "./breadcrumbs-title.module.css";

export function BreadcrumbsTitle({ className }: { className?: string }) {
  const { i18n } = useLingui();
  const params = useParams();
  const matches = useMatches();

  const crumbs = useMemo(() => {
    return matches
      .filter((match) => (match.handle as any)?.crumb)
      .map((match) => {
        const crumb = (match.handle as any)?.crumb;
        const value = typeof crumb === "function" ? crumb(params) : crumb;
        const label = typeof value === "string" ? value : i18n._(value);
        const noCrumbLink = (match.handle as any)?.noCrumbLink;
        return { label, noCrumbLink, pathname: match.pathname };
      });
  }, [matches, params, i18n]);

  return (
    <h2 className={cn("mb-9 mt-9 text-xl font-bold", className)}>
      {crumbs.map((crumb, index) => (
        <React.Fragment key={index}>
          {index === crumbs.length - 1 || crumb.noCrumbLink ? (
            <span className={styles.crumb}>{crumb.label}</span>
          ) : (
            <Link to={crumb.pathname} className={styles.crumb}>
              {crumb.label}
            </Link>
          )}
          {index !== crumbs.length - 1 ? " / " : ""}
        </React.Fragment>
      ))}
    </h2>
  );
}
